import React, { useState } from "react";
import { Button, Form } from "react-bootstrap";
import Select from "react-select";
import "./Repeatability_Form.css";
import { faCirclePlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function Repeatability_Form({ onProceed }) {
  const testTypeOptions = [
    { value: "repeatability", label: "Repeatability Test" },
    { value: "accuracy", label: "Accuracy Test" },
  ];

  const checkByOptions = [
    { value: "rahul", label: "Rahul Mali" },
    { value: "amit", label: "Amit Verma" },
  ];

  const [observations, setObservations] = useState(["", ""]);

  const handleObservationChange = (index, value) => {
    const updated = [...observations];
    updated[index] = value;
    setObservations(updated);
  };

  return (
    <section className="Legal_Entity_Form">
      <div className="white_container customer_section">
        <div className="row">
          {/* Test Type */}
          <div className="col-md-4">
            <Form.Group className="form_group">
              <Form.Label>Test Type</Form.Label>
              <Select
                options={testTypeOptions}
                placeholder="Select Test Type"
                classNamePrefix="react_select"
              />
            </Form.Group>
          </div>

          {/* Certified Value */}
          <div className="col-md-4">
            <Form.Group className="form_group">
              <Form.Label>Certified Value</Form.Label>
              <Form.Control placeholder="Certified Value" />
            </Form.Group>
          </div>
        </div>

        {/* Observations */}
        <div className="inner_form_section_holder">
          <div className="">
            <div className="heading_add_text">
              <div>
                <Form.Group className="form_group">
                  <Form.Label>Enter Observation</Form.Label>
                </Form.Group>
              </div>
              <div className="add_another_holder">
                <div>
                  <span>
                    <FontAwesomeIcon icon={faCirclePlus} /> Add Another Document
                  </span>
                </div>
              </div>
            </div>

            <div className="row">
              {observations.map((obs, index) => (
                <div key={index} className="col-xxl-1 col-xl-1 col-lg-2 col-md-3">
                  <div className="observation_box">
                    <div className="obs_label">
                      OBS {String(index + 1).padStart(2, "0")}
                    </div>
                    <div className="form_field_holder">
                      <Form.Control
                        value={obs}
                        onChange={(e) =>
                          handleObservationChange(index, e.target.value)
                        }
                      />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="row mt-3">
            {/* Average */}
            <div className="col-md-4">
              <Form.Group className="form_group">
                <Form.Label>Average</Form.Label>
                <Form.Control placeholder="Enter Average Value" />
              </Form.Group>
            </div>

            {/* Std Deviation */}
            <div className="col-md-4">
              <Form.Group className="form_group">
                <Form.Label>Std Deviation</Form.Label>
                <Form.Control placeholder="Std Deviation" />
              </Form.Group>
            </div>
          </div>

          <div className="row">
            {/* RSD */}
            <div className="col-md-4">
              <Form.Group className="form_group">
                <Form.Label>RSD</Form.Label>
                <Form.Control placeholder="RSD" />
              </Form.Group>
            </div>

            {/* Checked By */}
            <div className="col-md-4">
              <Form.Group className="form_group">
                <Form.Label>Checked By</Form.Label>
                <Select
                  options={checkByOptions}
                  placeholder="Select Checked By"
                  classNamePrefix="react_select"
                />
              </Form.Group>
            </div>
          </div>
        </div>

        {/* Footer Buttons */}
        <div className="permission_btn_holder">
          <Button className="permission_btn No_btn">Cancel</Button>
          <Button className="permission_btn Yes_btn" onClick={onProceed}>
            Save
          </Button>
        </div>
      </div>
    </section>
  );
}

export default Repeatability_Form;
